<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_edit_modal" :title="$t('edit')+$t('balance')" @on-ok="edit_balance">
            <Form :model="modalEdit" :label-width="100">
                <FormItem :label="$t('balance')">
                    <Input type="number" v-model="modalEdit.usd_balance"></Input>
                </FormItem>
            </Form>
        </Modal>
        
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            showDelModal: false,
            show_edit_modal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
           
            modalEdit: {
                user_id: 0,
                usd_balance: 0
            },
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "username"
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "mobile"
                },
                {
                    title: 'Email',
                    width: 150,
                    key: "email",
                },
                {
                    title:this.$i18n.t('network'),
                    key: "network",
                },
                {
                    title: this.$i18n.t('usd_balance'),
                    key: "usd_balance",
                },
                {
                    title: this.$i18n.t('edit'),
                    width:60,
                    align: "center",
                    render: (h, params) => {
                        return h('Icon', {
                            props: {
                                type: 'md-create',
                                size: 24,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'green',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.editCrypto(params.row);
                                }
                            }
                        });
                    }
                }
            ],
            data6: [],
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let path = this.search ? this.$path.user_search : this.$path.user;
            this.$get(path, {
                mobile: this.search,
                page: this.currentPage,
                type: "crypto"
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        editCrypto(row) {
            this.modalEdit.user_id = row.user_id;
            this.modalEdit.usd_balance = row.usd_balance;
            this.show_edit_modal = true;
        },
        edit_balance() {
            this.$post(this.$path.user_edit, {
                user_id: this.modalEdit.user_id,
                usd_balance: Number(this.modalEdit.usd_balance)
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/crypto/detail.vue